import * as React from 'react';
import { useState } from 'react';
import Box from "@material-ui/core/Box";
import { connect } from "react-redux"
import { Button, Container, createStyles, FormControl, Grid, makeStyles, MenuItem, Select, Theme } from "@material-ui/core";
import { ApplicationState } from "../../redux/reducers";
import { ICliente } from "../../entities/catalogos/ICliente";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import { IUsuario } from '../../entities/catalogos/IUsuario';
import { useHistory } from "react-router-dom";
import useCommonApi from '../../api/useCommonApi';
import { setSolicitud, setSolicitudCopia } from '../../redux/actions/solicitudActions';
import { enums } from '../../enums/enums';
import { useSnackbar } from 'notistack';
import Help, { IHelp } from '../help/Help';
import { traducirButton, traducirLabel, traducirMessage } from '../../blocks/traductor';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        principal: {
            height: '100%',
            minHeight: "300px",
            backgroundColor: "#fff",
            margin: "0px",
            padding: "10px",
        },
        title: {
            fontSize: "24px"
        },
        container: {
            paddingTop: "40px",
            paddingLeft: "40px"
        },
        text: {
            backgroundColor: "#fff",
            textTransform: "uppercase"
        },
        div_proyecto: {
            width: '100%',
        },
        label: {
            fontSize: '18px',
        },
        icon: {
            width: "40px",
            height: "40px",
            minWidth: "40px",
            borderRadius: "20px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "center",
            paddingTop: "5px"
        },
        actions: {
            paddingTop: "30px",
        },
        button: {

            backgroundColor: "#00653b",
            color: "#fff"
        },
        table: {
            minWidth: 650,
        },
    }),
);

interface OwnProps {

    siguienteSeccion: (siguienteSeccionId: number, datosSeccion: any, cotizacion_ID?: number, contacto?: any, datosRemitente?: any, datosDestinatario?: any, proyecto?: any, facturador?: any) => void
    cotizacionId: number
    tipo: string
}

interface StateProps {
    cliente: ICliente
    solicitud: Solicitud
    solicitudCopia: Solicitud
    usuario: IUsuario
    ayuda: IHelp
}

interface DispatchProps {
    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia
}

type Props = OwnProps & StateProps & DispatchProps

const Proyecto = (props: Props) => {
    const classes = useStyles();
    const [proyectos, setProyectos] = useState<any[]>([]);
    const [proyectoId, setProyectoId] = useState(-1);
    const apiSource = useCommonApi();
    const history = useHistory();

    const [proyecto, setProyecto] = useState<any>({
        id: -1,
        descripcion: ''
    });
    const [label, setLabel] = useState('');
    const { enqueueSnackbar } = useSnackbar();

    function regresarInicio() {
        history.push("/");
    }

    const configurarSolicitud = () => {
        const proyectoSeleccionado = proyectos.filter(m => m.id === proyecto);
        if (proyectoSeleccionado.length) {
            const filter = {
                id: proyectoSeleccionado[0].id,
                descripcion: proyectoSeleccionado[0].descripcion
            };
            setProyecto(filter);
        }

        if (proyecto.id <= 0) {
            const mensaje = traducirMessage(116); // `Favor de seleccionar el proyecto.`;
            enqueueSnackbar(mensaje, { variant: "error" });
            return;
        }

        if (props.tipo === 'cotizacion') {
            props.siguienteSeccion(enums.estatusSolicitud.origenDestino, null, 0, proyecto);
        } else {
            props.siguienteSeccion(props.cliente.habilitarClienteLogistico ? enums.estatusSolicitud.facturador : enums.estatusSolicitud.origenDestino, null, 0, null, null, null, proyecto);
        }
    };

    const getProyectosCliente = async () => {
        const result = await apiSource.obtenerAsync<any>("cliente-credito-proyecto/by-id/" + props.cliente.id);
        return result;
    };

    const getProyectosClienteProyecto = async () => await apiSource.obtenerAsync<any>(`cliente-credito-proyecto/by-cliente-proyecto?clienteId=${props.cliente.id}&proyectoId=${props.solicitud.proyecto?.id}`);

    const getGrupoProyectos = async () => {
        const result = await apiSource.obtenerAsync<any>("grupo-proyecto/proyectos/" + props.cliente.id);
        return result;
    };

    const handleProyecto = (event: React.ChangeEvent<{ value: unknown }>) => {
        setProyectoId(Number(event.target.value));
        const proyectoSeleccionado = proyectos.filter(m => m.id === Number(event.target.value));
        if (proyectoSeleccionado.length) {
            setProyecto(proyectoSeleccionado[0]);
        }
    }

    React.useEffect(() => {
        const loadProyectos = async () => {
            let proyectosCliente: any[] = [];
            const esGrupoCliente = props.cliente.grupoClienteID > 0;
            const result = esGrupoCliente ? await getGrupoProyectos() : props.solicitud.proyecto === undefined ? await getProyectosCliente() : await getProyectosClienteProyecto();
            result?.forEach(s => {
                const nuevoProyecto = {
                    id: esGrupoCliente ? s.id : s.clienteCreditoProyectoID,
                    descripcion: esGrupoCliente ? s.nombre : s.descripcion
                };

                proyectosCliente.push(nuevoProyecto);

                if (props.solicitud.proyecto?.id && nuevoProyecto.id === props.solicitud.proyecto?.id) {
                    setProyecto(nuevoProyecto);
                    setProyectoId(nuevoProyecto.id);
                }
            });

            setProyectos(proyectosCliente);
        }

        loadProyectos().then();

        if (props.tipo === 'cotizacion') {
            setLabel(traducirMessage(223)); //'Por favor seleccione el Proyecto al que estará ligada su Cotización');
        } else {
            setLabel(traducirMessage(224)); //'Por favor seleccione el Proyecto al que estará ligada su Solicitud de Servicio');
        }
    }, []);

    return (<>
        <Grid container spacing={4}>
            <Grid item xs={12}>
                <Container maxWidth="xl" className={classes.principal} >
                    <Box>
                        <Help comments={traducirMessage(242)} customStyle={{ top: "-25px", right: "-10px" }} />
                    </Box>

                    <Box display="flex" justifyContent="center" mt={2} className="title">
                        {label}
                    </Box>

                    <Grid container spacing={3} className={classes.container}>
                        <Grid item xs={12}>
                            <FormControl required fullWidth variant="outlined" >
                                <Select onChange={handleProyecto}
                                    labelId="proyecto-id"
                                    value={proyectoId}

                                    id="proyecto">

                                    {proyectos !== null && proyectos.map((option) => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.descripcion}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Container>
                <Grid container spacing={3} className={classes.actions}>
                    <Grid item xs={8} />

                    <Grid item xs={2}>
                        <Button variant="contained" color="default" onClick={() => regresarInicio()}>
                            {/* Cancelar */
                                traducirButton(6)}
                        </Button>
                    </Grid>

                    <Grid item xs={2}>
                        <Button variant="contained" color="primary" onClick={() => configurarSolicitud()}>
                            {/* Continuar */
                                traducirButton(7)}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    solicitud: state.solicitud,
    solicitudCopia: state.solicitudCopia,
    usuario: state.usuario,
    ayuda: state.ayuda
});

const mapDispatchToProps = {
    setSolicitud: setSolicitud,
    setSolicitudCopia: setSolicitudCopia,
};

export default connect(mapStateToProps, mapDispatchToProps)(Proyecto);